import { cva } from 'class-variance-authority';
import type { ToggleSizes } from './types';

// keeping empty strings here, so styles can be easily added without modifying any other file
export const toggleRootVariantsReset = cva('group/toggle', {
  variants: {
    checked: {
      false: '',
      true: '',
    },
    disabled: {
      false: '',
      true: '!cursor-not-allowed [&_*]:!cursor-not-allowed',
    },
    focusVisible: {
      false: '',
      true: '',
    },
  },
});

// Toggle paint lives in toggle.css on web so theme-manager selectors can override
// it without fighting Tailwind utility specificity. Native imports styles.native.ts
// because CSS component imports do not apply there.
export const toggleTrackVariants = cva('rounded-full relative', {
  variants: {
    checked: {
      false: '',
      true: '',
    },
    disabled: {
      false: '',
      true: '',
    },
    focusVisible: {
      false: '',
      true: '',
    },
    color: {
      brand: '',
      success: '',
      error: '',
    },
  },
  compoundVariants: [
    // background colors

    // neutral (or any color variant), unchecked (o-)
    {
      disabled: false,
      checked: false,
      className: '',
    },
    // neutral (or any color variant), unchecked (o-), disabled
    {
      disabled: true,
      checked: false,
      className: '',
    },
    // neutral (or any color variant), unchecked (o-), focused
    {
      focusVisible: true,
      checked: false,
      className: '',
    },

    // brand, checked (-o)
    {
      disabled: false,
      checked: true,
      color: 'brand',
      className: '',
    },
    // brand, checked (-o), disabled
    {
      disabled: true,
      checked: true,
      color: 'brand',
      className: '',
    },
    // brand, checked (-o), focussed
    {
      focusVisible: true,
      checked: true,
      color: 'brand',
      className: '',
    },


    // success, error, checked (-o)
    {
      disabled: false,
      checked: true,
      color: 'success',
      className: '',
    },
    {
      // -o
      disabled: false,
      checked: true,
      color: 'error',
      className: '',
    },
    // success, error, checked (-o), disabled
    {
      disabled: true,
      checked: true,
      color: 'success',
      className: '',
    },
    {
      disabled: true,
      checked: true,
      color: 'error',
      className: '',
    },
    // success, error, checked (-o), focussed
    {
      focusVisible: true,
      checked: true,
      color: 'success',
      className: '',
    },
    {
      focusVisible: true,
      checked: true,
      color: 'error',
      className: '',
    },
  ],
});

// keeping empty strings here, so styles can be easily added without modifying any other file
export const toggleThumbVariants = cva('rounded-full shadow-sm', {
  variants: {
    checked: {
      false: '',
      true: '',
    },
    disabled: {
      false: '',
      true: '',
    },
    focusVisible: {
      false: '',
      true: '',
    },
  },
});

// keeping empty strings here, so styles can be easily added without modifying any other file
export const toggleActionVariantsReset = cva('rounded-full', {
  variants: {
    checked: {
      false: '',
      true: '',
    },
    disabled: {
      false: '',
      true: '',
    },
    focusVisible: {
      false: '',
      true: '',
    },
  },
});

export const getScale = (size?: ToggleSizes) => {
  switch (size) {
    case 'xxs':
      return { width: 24, height: 14 };
    case 'xs':
      return { width: 28, height: 16 };
    case 'sm':
      return { width: 39, height: 21 };
    case 'md':
      return { width: 44, height: 24 };
    default:
      return { width: 39, height: 21 };
  }
};

export const getToggleLabelTextClassName = (size?: ToggleSizes) => {
  switch (size) {
    case 'xxs':
      return 'text-xxxs';
    case 'xs':
      return 'text-xxxs';
    case 'sm':
      return 'text-xxs';
    case 'md':
      return 'text-xs';
    default:
      return 'text-xxs';
  }
};

export const getLabeledScale = (size?: ToggleSizes) => {
  switch (size) {
    case 'xxs':
      // labeled variant is outside the figma frame; proportional step below xs
      return { width: 40, height: 16, thumb: 12 };
    case 'xs':
      return { width: 44, height: 20, thumb: 16 };
    case 'sm':
      return { width: 54, height: 26, thumb: 22 };
    case 'md':
      return { width: 64, height: 30, thumb: 26 };
    default:
      return { width: 54, height: 26, thumb: 22 };
  }
};
